<template>
  <div>
    <v-alert
      v-if="!userDataLoading && reviewsPackage.type == 'trial'"
      type="info"
      icon="timelapse"
      class="py-0 mb-4"
      mb-4
      prominent
      text
      dense
      >
      <v-row align="center">
        <v-col class="grow"><strong>Proefperiode</strong> van Reviews  is actief voor {{ activeCompData.name }}. </v-col>
        <v-col class="shrink">
          <v-btn
            color="info"
            outlined
            >
             Nog {{ reviewsPackage.days }} <span style="color: #2196f3" v-if="reviewsPackage.days == 1" >dag</span><span style="color: #2196f3" v-else>dagen</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-alert>  

    <transition name="fade">
      <div class="results-snackbar one clear" :style="{ backgroundColor: companyPrimaryColor }" :class="{ small: dualmode }" v-if="selectedOne.length > 0" >
        <v-container grid-list-md fluid class="ma-0 pa-1">
          <v-layout row wrap class="ma-0 pa-0">
            <v-flex :class="selectedSnackBarWidth">
              <div class="results-snackbar-close" @click="closeSnackbarOne()"></div>
              <div class="results-snackbar-selected clear">
                <div class="selected-branches">{{ selectedOne.length }}</div>
                <p>geselecteerd</p>
              </div>
            </v-flex>
            <v-flex :class="dataSnackBarWidth">
              <v-menu
                offset-y
                :close-on-content-click="false"
                transition="scale-transition"
                v-model="rangePickerOne"
              >
                <template v-slot:activator="{ on }">
                  <div class="results-select-data" :class="theme" v-on="on">
                    <div id="datepickerOne" class="datepicker-snackbar" >
                      <div style="height: 20px; overflow: hidden;"><span class="datepicker-label">Van: </span> <span class="datepicker-value">{{ dataFilterOneSaved.startDateFormatted }}</span></div>
                      <div><span class="datepicker-label">Tot: </span> <span class="datepicker-value">{{ dataFilterOneSaved.endDateFormatted }}</span></div>
                    </div>
                    <div class="custom-dropdown-icon v-input__icon v-input__icon--append"><i aria-hidden="true" class="v-icon material-icons">arrow_drop_down</i></div>
                  </div>
                </template>
                <v-card style="min-width: 500px">
                  <v-card-text class="pa-0 ma-0">
                    <v-container grid-list-md fluid class="ma-0 pa-0">
                      <v-layout row wrap class="ma-0 pa-0">
                        <v-flex md5  class="pa-0" style="border-right: 1px solid" :style="{borderColor: $vuetify.theme.themes[theme].menuborder}">
                          <div class="mx-1">
                            <h4 class="my-2 text-center">Selecteer periode</h4>
                            <v-btn class="my-1" small :color="companyPrimaryColor" :outlined="dataFilterOne.type != 'last30days'" dark block @click="pickRangeLast30DaysOne()">Afgelopen 30 dagen</v-btn>
                            <v-btn class="my-1" small :color="companyPrimaryColor" :outlined="dataFilterOne.type != 'currentMonth'"  dark block @click="pickRangeCurrentMonthOne()">Huidige maand</v-btn>
                            <v-btn class="my-1" small :color="companyPrimaryColor" :disabled="!dataFilterOne.lastMonthAvailable" :outlined="dataFilterOne.type != 'lastMonth'"  :dark="dataFilterOne.lastMonthAvailable" block @click="pickRangeLastMonthOne()">Vorige maand</v-btn>
                            <v-btn class="my-1" small :color="companyPrimaryColor" :outlined="dataFilterOne.type != 'currentQuarter'"  dark block @click="pickRangeCurrentQuarterOne()">Huidige kwartaal</v-btn>
                            <v-btn class="my-1" small :color="companyPrimaryColor" :disabled="!dataFilterOne.lastQuarterAvailable" :outlined="dataFilterOne.type != 'lastQuarter'" :dark="dataFilterOne.lastQuarterAvailable" block @click="pickRangeLastQuarterOne()">Vorige kwartaal</v-btn>
                            <v-btn :disabled="dataFilterOne.type != 'custom'" class="my-1" small :color="companyPrimaryColor" :dark="dataFilterOne.type == 'custom'" block :text="dataFilterOne.type != 'custom'" >Eigen selectie</v-btn>

                            <v-tooltip v-if="!dataFilterOne.lastMonthAvailable" bottom>
                              <template v-slot:activator="{ on }">
                                <div style="font-size: 12px; line-height: 16px; color:#777;" class="pt-3 text-center" v-on="on">
                                  <v-icon small :color="companyPrimaryColor">help</v-icon>
                                  <br>Waarom kan ik niet alle data selecteren?
                                </div>
                              </template>
                              <span style="color:white">De resultaten kunnen pas bekeken worden vanaf de startdatum.</span>
                            </v-tooltip>
                          </div>
                        </v-flex>
                        <v-flex md7>
                          <v-date-picker :min="minDateOne" :max="today" hide-details style="box-shadow: none!important" no-title :color="companyPrimaryColor" v-on:input="customDatePickedOne()" v-model="dataFilterOne.range" range></v-date-picker>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <span v-if="dataFilterOne.valid" style="font-size: 12px;">{{ dataFilterOne.startDateFormatted }} t/m {{ dataFilterOne.endDateFormatted }}</span>
                    <span v-else style="font-size: 12px;">Selecteer een begin en einddatum</span>
                    <v-spacer></v-spacer>
                    <v-btn class="mx-1" small color="#bfc5d2" outlined dark @click="cancelSelectedDateOne()">Annuleren</v-btn>
                    <v-btn class="mx-1" :disabled="!dataFilterOne.valid"  :depressed="!dataFilterOne.valid" small :color="companySecondaryColor" :dark="dataFilterOne.valid" @click="setSelectedDateOne()">Gebruiken <v-icon right>chevron_right</v-icon></v-btn>  
                  </v-card-actions>
                </v-card>
              </v-menu>
            </v-flex>
            <v-flex xs3>
              <v-select
                class="ma-0 pa-0"
                v-model="genderSelectedOne"
                :items="genderOptions"
                item-text="label"
                item-value="value"
                label="Geslacht"
                solo
                :background-color="$vuetify.theme.themes[theme].overlay"    
                :color="companyPrimaryColor"
                hide-details
                single-line
                flat
              ></v-select>
            </v-flex>
            <v-flex xs3>
              <v-btn class="ma-0" color="white" block large style="height: 48px; font-weight: 700!important;" :style="{ color: companyPrimaryColor}" @click="loadDataOne()" :dark="!loadingOne" :disabled="loadingOne" depressed >
                Resultaten
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
    </transition>

    <transition name="fade">
      <div class="results-snackbar two clear" :style="{ backgroundColor: companyPrimaryColor }" :class="{ small: dualmode }" v-if="selectedTwo.length > 0" >
        <v-container grid-list-md fluid class="ma-0 pa-1">
          <v-layout row wrap class="ma-0 pa-0">
            <v-flex xs2>
              <div class="results-snackbar-close" @click="closeSnackbarTwo()"></div>
              <div class="results-snackbar-selected clear">
                <div class="selected-branches">{{ selectedTwo.length }}</div>
                <p>geselecteerd</p>
              </div>
            </v-flex>
            <v-flex xs4>
              <v-menu
                offset-y
                :close-on-content-click="false"
                transition="scale-transition"
                v-model="rangePickerTwo"
              >
                <template v-slot:activator="{ on }">
                  <div class="results-select-data" :class="theme" v-on="on">
                    <div id="datepickerOne" class="datepicker-snackbar" >
                      <div style="height: 20px; overflow: hidden;"><span class="datepicker-label">Van: </span> <span class="datepicker-value">{{ dataFilterTwoSaved.startDateFormatted }}</span></div>
                      <div><span class="datepicker-label">Tot: </span> <span class="datepicker-value">{{ dataFilterTwoSaved.endDateFormatted }}</span></div>
                    </div>
                    <div class="custom-dropdown-icon v-input__icon v-input__icon--append"><i aria-hidden="true" class="v-icon material-icons">arrow_drop_down</i></div>
                  </div>
                </template>
                <v-card style="min-width: 500px">
                  <v-card-text class="pa-0 ma-0">
                    <v-container grid-list-md fluid class="ma-0 pa-0">
                      <v-layout row wrap class="ma-0 pa-0">
                        <v-flex md5  class="pa-0" style="border-right: 1px solid" :style="{borderColor: $vuetify.theme.themes[theme].menuborder}">
                          <div class="mx-1">
                            <h4 class="my-2 text-center">Selecteer periode</h4>
                            <v-btn class="my-1" small :color="companyPrimaryColor" :outlined="dataFilterTwo.type != 'last30days'" dark block @click="pickRangeLast30DaysTwo()">Afgelopen 30 dagen</v-btn>
                            <v-btn class="my-1" small :color="companyPrimaryColor" :outlined="dataFilterTwo.type != 'currentMonth'"  dark block @click="pickRangeCurrentMonthTwo()">Huidige maand</v-btn>
                            <v-btn class="my-1" small :color="companyPrimaryColor" :disabled="!dataFilterTwo.lastMonthAvailable" :outlined="dataFilterTwo.type != 'lastMonth'"  :dark="dataFilterTwo.lastMonthAvailable" block @click="pickRangeLastMonthTwo()">Vorige maand</v-btn>
                            <v-btn class="my-1" small :color="companyPrimaryColor" :outlined="dataFilterTwo.type != 'currentQuarter'"  dark block @click="pickRangeCurrentQuarterTwo()">Huidige kwartaal</v-btn>
                            <v-btn class="my-1" small :color="companyPrimaryColor" :disabled="!dataFilterTwo.lastQuarterAvailable" :outlined="dataFilterTwo.type != 'lastQuarter'" :dark="dataFilterTwo.lastQuarterAvailable" block @click="pickRangeLastQuarterTwo()">Vorige kwartaal</v-btn>
                            <v-btn :disabled="dataFilterTwo.type != 'custom'" class="my-1" small :color="companyPrimaryColor" :dark="dataFilterTwo.type == 'custom'" block :text="dataFilterTwo.type != 'custom'" >Eigen selectie</v-btn>

                            <v-tooltip v-if="!dataFilterTwo.lastMonthAvailable" bottom>
                              <template v-slot:activator="{ on }">
                                <div style="font-size: 12px; line-height: 16px; color:#777;" class="pt-3 text-center" v-on="on">
                                  <v-icon small :color="companyPrimaryColor">help</v-icon>
                                  <br>Waarom kan ik niet alle data selecteren?
                                </div>
                              </template>
                              <span style="color:white">De resultaten kunnen pas bekeken worden vanaf de startdatum.</span>
                            </v-tooltip>
                          </div>
                        </v-flex>
                        <v-flex md7>
                          <v-date-picker :min="minDateTwo" :max="today" hide-details style="box-shadow: none!important" no-title :color="companyPrimaryColor" v-on:input="customDatePickedTwo()" v-model="dataFilterTwo.range" range></v-date-picker>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <span v-if="dataFilterTwo.valid" style="font-size: 12px;">{{ dataFilterTwo.startDateFormatted }} t/m {{ dataFilterTwo.endDateFormatted }}</span>
                    <span v-else style="font-size: 12px;">Selecteer een begin en einddatum</span>
                    <v-spacer></v-spacer>
                    <v-btn class="mx-1" small color="#bfc5d2" outlined dark @click="cancelSelectedDateOne()">Annuleren</v-btn>
                    <v-btn class="mx-1" :disabled="!dataFilterTwo.valid"  :depressed="!dataFilterTwo.valid" small :color="companySecondaryColor" :dark="dataFilterOne.valid" @click="setSelectedDateTwo()">Gebruiken <v-icon right>chevron_right</v-icon></v-btn>  
                  </v-card-actions>
                </v-card>
              </v-menu>
            </v-flex>
            <v-flex xs3>
              <v-select
                class="ma-0 pa-0"
                v-model="genderSelectedTwo"
                :items="genderOptions"
                item-text="label"
                item-value="value"
                label="Geslacht"
                solo
                :background-color="$vuetify.theme.themes[theme].overlay"
                :color="companyPrimaryColor"
                hide-details
                single-line
                flat
              ></v-select>
            </v-flex>
            <v-flex xs3>
              <v-btn class="ma-0" color="white" block large style="height: 48px; font-weight: 700!important;" :style="{ color: companyPrimaryColor}" @click="loadDataTwo()" :disabled="loadingTwo" depressed >
                Resultaten
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
    </transition>

    <transition name="fade">
      <div class="overlay-one" :style="{backgroundColor: companyPrimaryColorRGBA + '0.3)'}" v-if="loadingOne">
        <div class="loading-icon-wrapper">
          <div class="loading-icon"></div>
          <div class="loading-text">Berekenen..</div>
        </div>
      </div>
    </transition>

    <transition name="fade">
      <div class="overlay-two" :style="{backgroundColor: companyPrimaryColorRGBA + '0.3)'}" v-if="loadingTwo">
        <div class="loading-icon-wrapper">
          <div class="loading-icon"></div>
          <div class="loading-text">Berekenen..</div>
        </div>
      </div>
    </transition>

    <div v-if="userDataLoading" class="blackbox-loader"></div>

    <div v-if="!userDataLoading">
      <!-- Content header -->
      <v-container grid-list-md class="pa-0 pt-2" fluid>
        <v-layout row wrap>
          <v-flex md3 xs12>
            <v-select
              :items="filteredJourneys"
              :item-color="companyPrimaryColor"
              :background-color="$vuetify.theme.themes[theme].menu"
              item-text="name"
              item-value="id"
              hide-details
              v-on:input="loadJourneyData()"
              v-model="selectedJourney"
              no-data-text="Geen bedrijven gevonden."
              label="Selecteer journey"
              outlined
              dense
              >
              <template v-slot:prepend-item>
                <v-list-item>
                  <v-list-item-content  class="pt-0" >
                    <v-text-field
                      :color="companyPrimaryColor"
                      placeholder="Zoeken"
                      prepend-inner-icon="search"
                      clearable
                      v-model="searchJourneys"
                      hide-details
                      dense
                    ></v-text-field>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <div v-if="searchJourneys.length > 0" style="padding: 4px 17px 3px 17px; background-color:rgba(0,0,0, 0.02); color: rgba(0, 0, 0, 0.6); text-align: center; font-size: 12px">{{ filteredJourneys.length }} van {{ journeys.length }} journeys</div>
                <v-divider v-if="searchJourneys.length > 0"></v-divider>
              </template>
            </v-select>
          </v-flex>
          <v-flex md9 xs12>
            <div class="text-right">
              <v-btn :color="singleModeColor" large dark depressed tile :outlined="dualmode" class="ma-0" style="border-right: none;" @click="singleMode(), closeSnackbarTwo()">Bekijken <v-icon right>fullscreen</v-icon></v-btn>
              <v-btn :color="dualModeColor" large dark depressed tile :outlined="!dualmode" class="ma-0" style="border-left: none;" @click="dualMode()">Vergelijken <v-icon right>compare_arrows</v-icon></v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-container>

      <!-- RESULTS -->
      <v-container grid-list-md class="ma-0 pa-0 mt-4" fluid>
        <v-layout row wrap>

          <!-- Resultbox 1 -->
          <v-flex :class="flexClass" class="pr-2"  d-flex>
            <v-card outlined style="width: 100%">
              

                <div class="data-no-results-wrapper" v-if="chartResultsOne.datasets.length == 0 && noSurveyDataOne == false">
                  <div class="data-no-results text-center">
                    <v-avatar size="170px" :color="$vuetify.theme.themes[theme].background">
                      <v-icon size="150px" :color="$vuetify.theme.themes[theme].menu">bar_chart</v-icon>
                    </v-avatar>
                    <div class="data-no-results-text">Selecteer 1 of meerdere vestigingen</div>
                  </div>
                </div>

                <div class="data-no-results-wrapper" v-if="chartResultsOne.datasets.length == 0 && noSurveyDataOne == true">
                  <div class="data-no-results text-center">
                    <v-avatar size="170px" :color="$vuetify.theme.themes[theme].background">
                      <v-icon size="150px" :color="$vuetify.theme.themes[theme].menu">bar_chart</v-icon>
                    </v-avatar>
                    <div class="data-no-results-text">Geen resultaten in deze periode.</div>
                  </div>
                </div>

                <div class="result-data" v-if="chartResultsOne.datasets.length > 0">
                  <v-card-text> 
                    <div class="results-summary-header clear" >
                      <div class="score-header">
                        <p class="mb-1">Score</p>
                        <p class="header-number ma-0">{{ (averangeRatingOne * 2).toFixed(1) }} / 10</p>
                      </div>
                      <div class="smile-header">
                        <p class="mb-1">Gemiddelde score</p>
                        <div class="smiley-score-wrapper">
                          <div class="smiley-score-overlay"></div>
                          <div class="smiley-score-underlay" v-bind:style="{ width: averangeRatingOnePercentage }"></div>
                        </div>
                      </div>
                      <div class="people-header">
                        <p class="mb-1">Respondenten</p>
                        <p class="header-number ma-0"> {{ responsesNumberOne }}</p>
                      </div>
                    </div>

                    <div class="results-graph clear">
                      <div class="legenda-wrapper">
                        <div class="legenda">
                          <p v-for="(data, index) in chartResultsOne.datasets" :key="index"><span v-bind:style="{backgroundColor: data.backgroundColor }" ></span>{{ data.name }}</p>
                        </div>
                      </div>

                      <div class="chart-container"  style="position: relative; height:200px;">
                        <bar-chart-one :chartData="chartResultsOne" :height="200" ref="BarChartOne" ></bar-chart-one>
                      </div>
                    </div>
                  
                    <div class="results-table-wrapper">
                      <h3>Aantal beantwoordde vragen per onderwerp:</h3>
                      <div class="table-items-wrapper header">
                        <div v-for="data in chartResultsOne.datasets" :key="data.subject" class="table-item" >{{ data.name }}</div>
                      </div>
                      <div class="table-items-wrapper">
                        <div  v-for="data in chartResultsOne.datasets" :key="data.subject" class="table-item"  v-bind:style="{color: data.backgroundColor }" > {{ data.total }}</div>
                      </div>
                    </div>
                  </v-card-text>

                  <div class="results-feedback-box-wrapper ">
                    <h2 style="color: #8B93A6; padding: 5px 0 0 15px">Feedback</h2>
                    <div class="pa-4 pb-0" v-if="responseDataFeedbackOneFiltered.length == 0">
                      <p style="color: #abb0bd;">Geen feedback aanwezig</p>
                    </div>
                    <div v-if="responseDataFeedbackOneFiltered.length > 0" class="results-feedback-box">
                        <v-data-table
                          :headers="feedbackHeaders"
                          :items="responseDataFeedbackOneFiltered"
                          :page.sync="resultsOnePage"
                          :items-per-page="5"
                          @page-count="pageCountResultsOne = $event"
                          class="feedback-table"
                          hide-default-footer
                          >
                          <template v-slot:item="{item}">
                            <tr>
                              <td style="color: #8B93A6;" class="text-xs-left">{{ item.dateSend.seconds | moment('D MMMM') }}</td>
                              <td style="color: #8B93A6;" class="text-xs-left">{{ item.clientName }}</td>
                              <td style="color: #8B93A6;" class="text-xs-left">{{ item.clientLastTreatmentByName }}</td>
                              <td class="text-xs-left">
                                <span v-for="(branch, index) in branches" :key="index">
                                  <span style="color: #8B93A6;" v-if="item.branchId == branch.id" >{{ branch.branchName }}</span>
                                </span>
                              </td>
                              <td style="color: #8B93A6;">
                                <span v-if="item.rating" class="client-data-smiley block" v-bind:class="'score-' + item.rating"></span>
                              </td>
                              <td style="color: #8B93A6;">
                                <span style="font-weight: 600; color: #8B93A6;">{{ item.question.nl }}</span><br>
                                {{ item.feedback }}
                              </td>
                            </tr>
                          </template>
                        </v-data-table>
                        <div class="text-xs-center pt-2" v-if="responseDataFeedbackOneFiltered.length > 5">
                          <v-pagination v-model="resultsOnePage" :color="companyPrimaryColor" :length="pageCountResultsOne"></v-pagination>
                        </div>
                        <div style="color: #8B93A6; margin: 15px 0 0 0; font-style: italic;" class="text-center pa-3" v-if="responseDataFeedbackOne.length > 25">Bekijk alle feedback van deze periode op de 
                          <router-link :to="`/journey-improvements`" custom v-slot="{ navigate }"><a @click="navigate">Verbeteringen</a></router-link> pagina.</div>
                    </div>
                  </div>
                </div>
              
            </v-card>
          </v-flex>

          <!-- Resultbox 2 -->
          <v-flex :class="flexClass" v-if="dualmode" class="pl-2"  d-flex>
            <v-card outlined style="width: 100%">
              <div class="data-no-results-wrapper" v-if="chartResultsTwo.datasets.length == 0 && noSurveyDataTwo == false">
                <div class="data-no-results text-center">
                  <v-avatar size="170px" :color="$vuetify.theme.themes[theme].background">
                    <v-icon size="150px" :color="$vuetify.theme.themes[theme].menu">bar_chart</v-icon>
                  </v-avatar>
                  <div class="data-no-results-text">Selecteer 1 of meerdere vestigingen</div>
                </div>
              </div>

              <div class="data-no-results-wrapper" v-if="chartResultsTwo.datasets.length == 0 && noSurveyDataTwo == true">
                <div class="data-no-results text-center">
                  <v-avatar size="170px" :color="$vuetify.theme.themes[theme].background">
                    <v-icon size="150px" :color="$vuetify.theme.themes[theme].menu">bar_chart</v-icon>
                  </v-avatar>
                  <div class="data-no-results-text">Geen resultaten in deze periode.</div>
                </div>
              </div>

              <div class="result-data" v-if="chartResultsTwo.datasets.length > 0">
                <v-card-text>  
                  <div class="results-summary-header clear" v-bind:class="{ hide : !dataTwo}" >
                    <div class="score-header">
                      <p class="mb-1">Score</p>
                      <p class="header-number ma-0">{{ (averangeRatingTwo * 2).toFixed(1) }} / 10</p>
                    </div>
                    <div class="smile-header">
                      <p class="mb-1">Gemiddelde score</p>
                      <div class="smiley-score-wrapper">
                        <div class="smiley-score-overlay"></div>
                        <div class="smiley-score-underlay" v-bind:style="{ width: averangeRatingTwoPercentage }"></div>
                      </div>
                    </div>
                    <div class="people-header">
                      <p class="mb-1">Respondenten</p>
                      <p class="header-number ma-0"> {{ responsesNumberTwo }}</p>
                    </div>
                  </div>

                  <div class="results-graph clear">
                    <div class="legenda-wrapper">
                      <div class="legenda">
                        <p v-for="data in chartResultsTwo.datasets" :key="data.subject"><span v-bind:style="{backgroundColor: data.backgroundColor }" ></span>{{ data.name }}</p>
                      </div>
                    </div>

                    <div class="data-no-results-wrapper" v-bind:class="{ hide : dataTwo }">
                      <div class="data-no-results">
                        <div class="data-no-results-icon"></div>
                        <div class="data-no-results-text">Selecteer 1 of meerdere filialen</div>
                      </div>
                    </div>

                    <div class="chart-container"  v-bind:class="{ hide : !dataTwo}" style="position: relative; height:200px;">
                      <bar-chart-two :chartData="chartResultsTwo" :height="200" ref="BarChartTwo"></bar-chart-two>
                    </div>
                  </div>

                  <div class="results-table-wrapper" v-bind:class="{ hide : !dataTwo }">
                    <h3>Aantal beantwoordde vragen per onderwerp:</h3>
                    <div class="table-items-wrapper header">
                      <div v-for="data in chartResultsTwo.datasets" :key="data.subject" class="table-item" >{{ data.name  }}</div>
                    </div>
                    <div class="table-items-wrapper">
                      <div  v-for="data in chartResultsTwo.datasets" :key="data.subject" class="table-item"  v-bind:style="{color: data.backgroundColor }" > {{ data.total }}</div>
                    </div>
                  </div>
                </v-card-text>

                <div class="results-feedback-box-wrapper">
                  <h2 style="color: #8B93A6; padding: 5px 0 0 15px">Feedback</h2>
                  <div v-if="responseDataFeedbackTwoFiltered.length == 0">
                    <p style="color: #abb0bd;">Geen feedback aanwezig</p>
                  </div>

                  <div v-if="responseDataFeedbackTwoFiltered.length > 0" class="results-feedback-box">
                    <v-data-table
                      :headers="feedbackHeaders"
                      :items="responseDataFeedbackTwoFiltered"
                      :page.sync="resultsTwoPage"
                      :items-per-page="5"
                      @page-count="pageCountResultsTwo = $event"
                      class="feedback-table"
                      hide-default-footer
                      >
                      <template v-slot:item="{item}">
                        <tr>
                          <td style="color: #8B93A6;" class="text-xs-left">{{ item.dateSend.seconds | moment('D MMM') }}</td>
                          <td style="color: #8B93A6;" class="text-xs-left">{{ item.clientName }}</td>
                          <td style="color: #8B93A6;" class="text-xs-left">{{ item.clientLastTreatmentByName }}</td>
                          <td class="text-xs-left">
                            <span v-for="branch in branches" :key="branch.id">
                              <span style="color: #8B93A6;" v-if="item.branchId == branch.id" >{{ branch.branchName }}</span>
                            </span>
                          </td>
                          <td style="color: #8B93A6;">
                            <span v-if="item.rating" class="client-data-smiley block" v-bind:class="'score-' + item.rating"></span>
                          </td>
                          <td style="color: #8B93A6;">
                            <span style="font-weight: 600; color: #8B93A6;">{{ item.question.nl }}</span><br>
                            {{ item.feedback }}
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                    <div class="text-xs-center pt-2" v-if="responseDataFeedbackTwoFiltered.length > 5">
                      <v-pagination v-model="resultsTwoPage" :color="companyPrimaryColor" :length="pageCountResultsTwo"></v-pagination>
                    </div>
                    <div style="color: #8B93A6; margin: 15px 0 0 0; font-style: italic;" class="text-center pa-2" v-if="responseDataFeedbackTwo.length > 25">Bekijk alle feedback van deze periode op de <router-link tag="a" class="menu-item" :to="`/journey-improvements`">Verbeteringen</router-link > pagina.</div>
            
                  </div>
                </div>
              </div>

              <div class="results-empty-wrapper"> </div>
            </v-card>
          </v-flex>

          <!-- Branches 1 -->
          <v-flex :class="flexClass" class="pr-2"  d-flex>
            <v-card width="100%" outlined>
              <v-card-title>
                <h4>Selecteer vestigingen</h4>
                <v-spacer></v-spacer>
                <v-text-field
                  style="max-width: 300px;"
                  v-model="searchBranchesOne"
                  :color="companyPrimaryColor"
                  placeholder="Zoeken"
                  outlined
                  dense
                  hide-details     
                  :background-color="$vuetify.theme.themes[theme].menu"                                                
                  prepend-inner-icon="search"
                  autocomplete="disabled"
                  clearable>
                </v-text-field>                 
              </v-card-title>

              <v-data-table
                @toggle-select-all="branchSelectedOne()"
                @item-selected="branchSelectedOne()"
                :headers="headers"
                :items="branches"
                show-select
                :color="companyPrimaryColor"
                v-model="selectedOne"
                :search="searchBranchesOne"
                hide-default-footer
                item-select
                :items-per-page="10"
                :page.sync="branchesOnePage"
                @page-count="pageCountBranchesOne = $event"
                :no-results-text="`Geen resultaten gevonden voor: ${searchBranchesOne}`"
                >

                <template v-slot:item="{item, isSelected, select}">
                  <tr>
                    <td>
                      <v-icon @click="select(true)" v-if="!isSelected" >check_box_outline_blank</v-icon>
                      <v-icon @click="select(false)" v-if="isSelected" :color="companyPrimaryColor">check_box</v-icon>
                    </td>
                    <td>
                      <span v-for="company in companies" :key="company.id">
                        <span v-if="company.id == item.compId ">{{ company.name }} - {{ item.branchName }}</span>
                      </span>
                      </td>
                    <td>{{ item.province }}</td>
                    <td>{{ item.country }}</td>
                  </tr>
                </template>
              </v-data-table>

              <div class="text-xs-center py-2" v-if="branches.length > 10">
                <v-pagination v-model="branchesOnePage" :color="companyPrimaryColor" :length="pageCountBranchesOne"></v-pagination>
              </div>
    
            </v-card>
          </v-flex>
          
          <!-- Branches 2 -->
          <v-flex :class="flexClass" class="pl-2" v-if="dualmode" d-flex>
            <v-card width="100%" outlined>
              <v-card-title>
                <h4>Selecteer vestigingen</h4>
                <v-spacer></v-spacer>
                <v-text-field
                  style="max-width: 300px;"
                  v-model="searchBranchesTwo"
                  :color="companyPrimaryColor"
                  placeholder="Zoeken"
                  outlined
                  dense
                  hide-details     
                  :background-color="$vuetify.theme.themes[theme].menu"                                                
                  prepend-inner-icon="search"
                  autocomplete="disabled"
                  clearable>
                </v-text-field>                 
              </v-card-title>

              <v-data-table
                @toggle-select-all="branchSelectedTwo()"
                @item-selected="branchSelectedTwo()"
                :headers="headers"
                :items="branches"
                show-select
                :color="companyPrimaryColor"
                v-model="selectedTwo"
                :search="searchBranchesTwo"
                hide-default-footer
                item-select
                :items-per-page="10"
                :page.sync="branchesTwoPage"
                @page-count="pageCountBranchesTwo = $event"
                :no-results-text="`Geen resultaten gevonden voor: ${searchBranchesTwo}`"
                >
                <template v-slot:item="{item, isSelected, select}">
                  <tr>
                    <td>
                      <v-icon @click="select(true)" v-if="!isSelected" >check_box_outline_blank</v-icon>
                      <v-icon @click="select(false)" v-if="isSelected" :color="companyPrimaryColor">check_box</v-icon>
                    </td>
                    <td>
                      <span v-for="company in companies" :key="company.id">
                        <span v-if="company.id == item.compId ">{{ company.name }}</span>
                      </span>
                      - {{ item.branchName }}</td>
                    <td>{{ item.province }}</td>
                    <td>{{ item.country }}</td>
                  </tr>
                </template>
              </v-data-table>

              <div class="text-xs-center py-2" v-if="branches.length > 10">
                <v-pagination v-model="branchesTwoPage" :color="companyPrimaryColor" :length="pageCountBranchesTwo"></v-pagination>
              </div>
    
            </v-card>
          </v-flex>

        </v-layout>
      </v-container>
    </div>    
  </div>
</template>

<script>
// import { Bar } from 'vue-chartjs'
import { bus } from "../main";
import db from "../firebase/init";
import BarChartOne from "../components/elements/BarChartOne.js";
import BarChartTwo from "../components/elements/BarChartTwo.js";
import { log } from "util";
import moment from "moment";

export default {
  // extends: Bar,
  components: {
    BarChartOne,
    BarChartTwo,
  },

  name: "journey-results",
  data: () => ({
    today: null,
    activeComp: null,
    activeCompData: null,
    activeCompDataOriginal: null,
    selectedJourney: null,
    dualmode: false,
    results: {},
    stages: [],
    journeys: [],
    companies: [],
    branches: [],
    userDataLoading: true,
    date: null,
    menu: false,
    questionData: [],
    questionDataChart: [],
    
    searchJourneys: "",

    // COMPARE ITEM ONE
    dataFilterOne: {
      range: [],
      startDateFormatted: null,
      endDateFormatted: null,
      type: 'last30days',
      lastMonthAvailable: false,
      lastQuarterAvailable: false,
      valid: true
    },
    dataFilterOneSaved: {
      range: [],
      startDateFormatted: null,
      endDateFormatted: null,
      lastMonthAvailable: false,
      lastQuarterAvailable: false,
      type: 'last30days',
      valid: true
    },
    minDateOne: null,
    minDateMomentOne: null,
    rangePickerOne: false,
    responseDataOne: [],
    responseDataFeedbackOne: [],
    minDateBranchOne: null,
    selectedStartDateOne: "",
    selectedEndDateOne: "",
    genderSelectedOne: "all",
    chartResultsOne: {
      datasets: [],
    },
    paginationFeedbackOne: {
      rowsPerPage: 5,
      descending: true,
      sortBy: "dateSend.seconds",
    },
    loadingOne: false,
    searchOne: "",
    searchBranchesOne:"",
    averangeRatingOne: "",
    averangeRatingOnePercentage: "",
    responsesNumberOne: "",
    noSurveyDataOne: false,
    selectedOne: [],
    dataOne: false,
    surveysOne: [],
    surveyDataOne: [],
    branchesOnePage: 1,
    pageCountBranchesOne: 0,
    resultsOnePage: 1,
    pageCountResultsOne: 0,

    // COMPARE ITEM TWO
    dataFilterTwo: {
      range: [],
      startDateFormatted: null,
      endDateFormatted: null,
      lastMonthAvailable: false,
      lastQuarterAvailable: false,
      type: 'last30days',
      valid: true
    },
    dataFilterTwoSaved: {
      range: [],
      startDateFormatted: null,
      endDateFormatted: null,
      lastMonthAvailable: false,
      lastQuarterAvailable: false,
      type: 'last30days',
      valid: true
    },
    rangePickerTwo: false,
    searchBranchesTwo: "",
    responseDataTwo: [],
    responseDataFeedbackTwo: [],
    minDateTwo: null,
    minDateMomentTwo: null,
    minDateBranchTwo: null,
    genderSelectedTwo: "all",
    branchesTwoPage: 1,
    pageCountBranchesTwo: 0,
    resultsTwoPage: 1,
    pageCountResultsTwo: 0,
    chartResultsTwo: {
      datasets: []
    },
    paginationFeedbackTwo: {
      rowsPerPage: 5,
      descending: true,
      sortBy: "dateSend.seconds"
    },
    paginationTwo: {
      sortBy: "branchName",
      rowsPerPage: 10,
      descending: false
    },

    loadingTwo: false,
    averangeRatingTwoPercentage: "",
    responsesNumberTwo: "",
    averangeRatingTwo: "",
    noSurveyDataTwo: false,
    selectedTwo: [],
    dataTwo: false,

    headers: [
      {
        text: "Vestiging",
        align: "left",
        value: "branchName"
      },
      {
        text: "Regio",
        align: "left",
        value: "province"
      },
      {
        text: "Land",
        align: "left",
        value: "country"
      }
    ],
    feedbackHeaders: [
      {
        text: "Datum",
        align: "left",
        value: "dateSend.seconds",
        sortable: false,
        width: "100px"
      },
      {
        text: "Klant",
        align: "left",
        value: "country",
        sortable: false,
        width: "100px"
      },
      {
        text: "Medewerker",
        align: "left",
        value: "question",
        sortable: false
      },
      {
        text: "Salon",
        align: "left",
        value: "branch",
        sortable: false,
        width: "100px"
      },
      {
        text: "Emotie",
        align: "left",
        value: "rating",
        sortable: false,
        width: "55px"
      },
      {
        text: "Feedback",
        align: "left",
        value: "feedback",
        sortable: false
      }
    ],
    genderOptions: [
      {
        label: "Mannen",
        value: "male"
      },
      {
        label: "Vrouwen",
        value: "female"
      },
      {
        label: "Iedereen",
        value: "all"
      }
    ]
  }),

  created() {
    this.today = moment().format("YYYY-MM-DD");
  },

  mounted() {
    this.loadUserComp();
  },

  methods: {

    loadUserComp() {
      this.userDataLoading = true
      let userCompanies = this.userCompanies;
      this.companies = [];
      let counter = 0
      if(this.userRole == 'superadmin'){
        db.collection("companies")
        .get()
        .then(snap => {
          snap.forEach(doc => {
            let company = {};
            company.name = doc.data().name;
            company.journeys = doc.data().journeys;
            company.id = doc.id;
            this.companies.push(company);
          });
        })
        .then(()=>{
          let counter = 0
          new Promise((resolve, reject) =>{
            this.companies.forEach(company => {
            // Load Journeys
            db.collection("journeys")
              .where(`companies.${company.id}`, "==", true)
              .get()
              .then(snap => {
                snap.forEach(doc => {
                  let journeyCollection = doc.data();
                  journeyCollection.id = doc.id;
                  this.journeys.push(journeyCollection);
                });
              })
              .then(()=>{
                counter++
                if(counter == this.companies.length){
                  resolve()
                }
              })
              .catch(()=>{
                console.error("Error");
                counter++
                if(counter == this.companies.length){
                  resolve()
                }
              })
            });
          })
          .then(()=>{
            if(this.journeys.length > 0){

              // REMEMBER SELECTED COMPANY FROM LOCAL STORAGE
              if(this.userRole == 'superadmin'){
                // Super Admins have access to multiple companies 
                let selectedCompany = window.localStorage.getItem('selectedCompany')
                // Check if a selected company is set in the Local Storage
                if(selectedCompany){
        
                  this.activeComp = selectedCompany
                  // Check if the selected company is an option
                  let selectedCompanyIndex = _.findIndex(this.companies, { 'id': selectedCompany })

                  // Selected company is an option, set activeComp
                  if(selectedCompanyIndex >= 0){
                    let companyJourneys = []
                    this.journeys.forEach(journey =>{
                      if(journey.companies[selectedCompany]){
                        companyJourneys.push(journey)
                      }
                    })
                    if(companyJourneys.length > 0){
                      this.selectedJourney = companyJourneys[0].id
                    } else {
                      this.selectedJourney = this.journeys[0].id
                    }
                  } 
                  // Selected company is no option, set first company as activeComp 
                  else{
                    this.selectedJourney = this.journeys[0].id
                    window.localStorage.setItem('selectedCompany', this.companies[0].id)
                    this.activeComp = this.companies[0].id
                  }
                }
                // No selected company is set 
                else {
                  this.selectedJourney = this.journeys[0].id
                  window.localStorage.setItem('selectedCompany', this.companies[0].id)
                  this.activeComp = this.companies[0].id
                }
              }

            } else{
              console.log("Niet groter dan null");
              this.selectedJourney = null
            }
          })
          .then(()=>{
            this.loadJourneyData();
          })
        })
        
      } else{
        db.collection("companies")
          .doc(this.userCompany)
          .get()
          .then(doc => {
            let company = {};
            company.name = doc.data().name;
            company.id = doc.id;
            company.journeys = doc.data().journeys;
            this.companies.push(company);
          })
          .then(()=>{
            let counter = 0
            new Promise((resolve, reject) =>{
              this.companies.forEach(company => {
              // Load Journeys
              db.collection("journeys")
                .where(`companies.${company.id}`, "==", true)
                .get()
                .then(snap => {
                  snap.forEach(doc => {
                    let journeyCollection = doc.data();
                    journeyCollection.id = doc.id;
                    this.journeys.push(journeyCollection);
                  });
                })
                .then(()=>{
                  counter++
                  if(counter == this.companies.length){
                    resolve()
                  }
                })
                .catch(()=>{
                  counter++
                  if(counter == this.companies.length){
                    resolve()
                  }
                })
              });
            })
            .then(()=>{
              if(this.journeys.length > 0){
                console.log("Groter dan null");
                this.selectedJourney = this.journeys[0].id
              } else{
                console.log("Niet groter dan null");
                this.selectedJourney = null
              }
            })
            .then(()=>{
              this.loadJourneyData();
            })
          })
          
      }
      
    },

    branchesLoaded() {
      this.minDate = "";
      let minDateBranches = [];
      let latestDate = null;
      let startDate = this.startDate;
      this.branches.forEach(element => {
        if (element.firstSurveyDate) {
          let dateNumberSeconds = Number(element.firstSurveyDate.seconds);
          minDateBranches.push(dateNumberSeconds);
        }
      });
      if(minDateBranches.length > 0){
        this.minDateBranchOne = Math.min.apply(null, minDateBranches);
        this.minDateBranchTwo = Math.min.apply(null, minDateBranches);
      }
      this.userDataLoading = false
    },

    branchSelectedOne() {
      setTimeout(()=> {
        this.minDateBranchOne = null;
        let minDateBranches = [];
        let latestDate = null;

        if(this.selectedOne.length > 0){
          let counter = 0
          new Promise((resolve, reject)=>{
            this.selectedOne.forEach(branch => {
              if (branch.firstSurveyDate) {
                let dateNumberSeconds = Number(branch.firstSurveyDate.seconds);
                minDateBranches.push(dateNumberSeconds);
              }
              counter++
              if(counter == this.selectedOne.length){
                resolve()
              }
            });
          })
          .then(()=>{
            this.minDateBranchOne = Math.min.apply(null, minDateBranches);
          })
          .then(()=>{
            this.setMininumDateOne();
          })
        } 
      }, 100);    
    },

    pickRangeLast30DaysOne(){
      this.dataFilterOne.range = [] 
      let start = moment().subtract(30, "days")
      let end = moment()
      if(start < this.minDateMomentOne){
        start = this.minDateMomentOne
      }
      this.dataFilterOne.range.push(moment(start).format("YYYY-MM-DD"))
      this.dataFilterOne.range.push(moment(end).format("YYYY-MM-DD"))
      this.dataFilterOne.startDateFormatted = moment(start).format("D MMM YYYY")
      this.dataFilterOne.endDateFormatted = moment(end).format("D MMM YYYY")
      this.dataFilterOne.type = "last30days"
      this.dataFilterOne.valid = true
    },

    pickRangeLast30DaysTwo(){
      this.dataFilterTwo.range = [] 
      let start = moment().subtract(30, "days")
      let end = moment()
      if(start < this.minDateMomentTwo){
        start = this.minDateMomentTwo
      }
      this.dataFilterTwo.range.push(moment(start).format("YYYY-MM-DD"))
      this.dataFilterTwo.range.push(moment(end).format("YYYY-MM-DD"))
      this.dataFilterTwo.startDateFormatted = moment(start).format("D MMM YYYY")
      this.dataFilterTwo.endDateFormatted = moment(end).format("D MMM YYYY")
      this.dataFilterTwo.type = "last30days"
      this.dataFilterTwo.valid = true
    },


    pickRangeCurrentMonthOne(){
      this.dataFilterOne.range = []
      let start = moment().startOf('month')
      let end = moment()
      if(start < this.minDateMomentOne){
        start = this.minDateMomentOne
      }
      this.dataFilterOne.range.push(moment(start).format("YYYY-MM-DD")) 
      this.dataFilterOne.range.push(moment(end).format("YYYY-MM-DD"))
      this.dataFilterOne.startDateFormatted = moment(start).format("D MMM YYYY")
      this.dataFilterOne.endDateFormatted = moment(end).format("D MMM YYYY")
      this.dataFilterOne.type = "currentMonth"
      this.dataFilterOne.valid = true
    },

    pickRangeCurrentMonthTwo(){
      this.dataFilterTwo.range = []
      let start = moment().startOf('month')
      let end = moment()
      if(start < this.minDateMomentTwo){
        start = this.minDateMomentTwo
      }
      this.dataFilterTwo.range.push(moment(start).format("YYYY-MM-DD")) 
      this.dataFilterTwo.range.push(moment(end).format("YYYY-MM-DD"))
      this.dataFilterTwo.startDateFormatted = moment(start).format("D MMM YYYY")
      this.dataFilterTwo.endDateFormatted = moment(end).format("D MMM YYYY")
      this.dataFilterTwo.type = "currentMonth"
      this.dataFilterTwo.valid = true
    },

    pickRangeLastMonthOne(){
      this.dataFilterOne.range = []
      let start = moment().subtract(1,'months').startOf('month')
      let end = moment().subtract(1,'months').endOf('month')
      if(start < this.minDateMomentOne){
        start = this.minDateMomentOne
      }
      this.dataFilterOne.range.push(moment(start).format("YYYY-MM-DD"))
      this.dataFilterOne.range.push(moment(end).format("YYYY-MM-DD"))  
      this.dataFilterOne.startDateFormatted = moment(start).format("D MMM YYYY")
      this.dataFilterOne.endDateFormatted = moment(end).format("D MMM YYYY")
      this.dataFilterOne.type = "lastMonth"
      this.dataFilterOne.valid = true
    },

    pickRangeLastMonthTwo(){
      this.dataFilterTwo.range = []
      let start = moment().subtract(1,'months').startOf('month')
      let end = moment().subtract(1,'months').endOf('month')
      if(start < this.minDateMomentTwo){
        start = this.minDateMomentTwo
      }
      this.dataFilterTwo.range.push(moment(start).format("YYYY-MM-DD"))
      this.dataFilterTwo.range.push(moment(end).format("YYYY-MM-DD"))  
      this.dataFilterTwo.startDateFormatted = moment(start).format("D MMM YYYY")
      this.dataFilterTwo.endDateFormatted = moment(end).format("D MMM YYYY")
      this.dataFilterTwo.type = "lastMonth"
      this.dataFilterTwo.valid = true
    },

    pickRangeCurrentQuarterOne(){
      this.dataFilterOne.range = []
      let start = moment().startOf('quarter')
      let end = moment()
      if(start < this.minDateMomentOne){
        start = this.minDateMomentOne
      }
      this.dataFilterOne.range.push(moment(start).format("YYYY-MM-DD"))
      this.dataFilterOne.range.push(moment(end).format("YYYY-MM-DD"))   
      this.dataFilterOne.startDateFormatted = moment(start).format("D MMM YYYY")
      this.dataFilterOne.endDateFormatted = moment(end).format("D MMM YYYY")
      this.dataFilterOne.type = "currentQuarter"
      this.dataFilterOne.valid = true
    },

    pickRangeCurrentQuarterTwo(){
      this.dataFilterTwo.range = []
      let start = moment().startOf('quarter')
      let end = moment()
      if(start < this.minDateMomentTwo){
        start = this.minDateMomentTwo
      }
      this.dataFilterTwo.range.push(moment(start).format("YYYY-MM-DD"))
      this.dataFilterTwo.range.push(moment(end).format("YYYY-MM-DD"))   
      this.dataFilterTwo.startDateFormatted = moment(start).format("D MMM YYYY")
      this.dataFilterTwo.endDateFormatted = moment(end).format("D MMM YYYY")
      this.dataFilterTwo.type = "currentQuarter"
      this.dataFilterTwo.valid = true
    },

    pickRangeLastQuarterOne(){
      this.dataFilterOne.range = []
      let start = moment().subtract(1,'quarter').startOf('quarter')
      let end = moment().subtract(1,'quarter').endOf('quarter')
      if(start < this.minDateMomentOne){
        start = this.minDateMomentOne
      }
      this.dataFilterOne.range.push(moment(start).format("YYYY-MM-DD"))
      this.dataFilterOne.range.push(moment(end).format("YYYY-MM-DD"))   
      this.dataFilterOne.startDateFormatted = moment(start).format("D MMM YYYY")
      this.dataFilterOne.endDateFormatted = moment(end).format("D MMM YYYY")
      this.dataFilterOne.type = "lastQuarter"
      this.dataFilterOne.valid = true
    },

    pickRangeLastQuarterTwo(){
      this.dataFilterTwo.range = []
      let start = moment().subtract(1,'quarter').startOf('quarter')
      let end = moment().subtract(1,'quarter').endOf('quarter')
      if(start < this.minDateMomentTwo){
        start = this.minDateMomentTwo
      }
      this.dataFilterTwo.range.push(moment(start).format("YYYY-MM-DD"))
      this.dataFilterTwo.range.push(moment(end).format("YYYY-MM-DD"))   
      this.dataFilterTwo.startDateFormatted = moment(start).format("D MMM YYYY")
      this.dataFilterTwo.endDateFormatted = moment(end).format("D MMM YYYY")
      this.dataFilterTwo.type = "lastQuarter"
      this.dataFilterTwo.valid = true
    },

    customDatePickedOne(){
      this.dataFilterOne.type = "custom"
      if(this.dataFilterOne.range[1]){
        if(this.dataFilterOne.range[1] < this.dataFilterOne.range[0]){
          let first = _.cloneDeep(this.dataFilterOne.range[0])
          let last = _.cloneDeep(this.dataFilterOne.range[1])
          this.dataFilterOne.range[0] = last
          this.dataFilterOne.range[1] = first
          this.dataFilterOne.valid = true
        } else{
          this.dataFilterOne.valid = true
        }
      } else{
        this.dataFilterOne.valid = false
      }
      this.dataFilterOne.startDateFormatted = moment(this.dataFilterOne.range[0]).format("D MMM YYYY")
      this.dataFilterOne.endDateFormatted = moment(this.dataFilterOne.range[1]).format("D MMM YYYY")
    },

    customDatePickedTwo(){
      this.dataFilterTwo.type = "custom"
      if(this.dataFilterTwo.range[1]){
        if(this.dataFilterTwo.range[1] < this.dataFilterTwo.range[0]){
          let first = _.cloneDeep(this.dataFilterTwo.range[0])
          let last = _.cloneDeep(this.dataFilterTwo.range[1])
          this.dataFilterTwo.range[0] = last
          this.dataFilterTwo.range[1] = first
          this.dataFilterTwo.valid = true
        } else{
          this.dataFilterTwo.valid = true
        }
      } else{
        this.dataFilterTwo.valid = false
      }
      this.dataFilterTwo.startDateFormatted = moment(this.dataFilterTwo.range[0]).format("D MMM YYYY")
      this.dataFilterTwo.endDateFormatted = moment(this.dataFilterTwo.range[1]).format("D MMM YYYY")
    },

    setSelectedDateOne(){
      this.rangePickerOne = false
      this.dataFilterOneSaved = _.cloneDeep(this.dataFilterOne)
    },

    setSelectedDateTwo(){
      this.rangePickerTwo = false
      this.dataFilterTwoSaved = _.cloneDeep(this.dataFilterTwo)
    },

    cancelSelectedDateOne(){
      this.rangePickerOne = false
      this.dataFilterOne = _.cloneDeep(this.dataFilterOneSaved)   
    },

    branchSelectedTwo() {
      setTimeout(()=> {
        this.minDateBranchTwo = null;
        let minDateBranches = [];
        let latestDate = null;

        if(this.selectedTwo.length > 0){
          let counter = 0
          new Promise((resolve, reject)=>{
            this.selectedTwo.forEach(branch => {
              if (branch.firstSurveyDate) {
                let dateNumberSeconds = Number(branch.firstSurveyDate.seconds);
                minDateBranches.push(dateNumberSeconds);
              }
              counter++
              if(counter == this.selectedTwo.length){
                resolve()
              }
            });
          })
          .then(()=>{
            this.minDateBranchTwo = Math.min.apply(null, minDateBranches);
          })
          .then(()=>{
            this.setMininumDateTwo();
          })
        }
      }, 100);
    },

    setMininumDateOne() {
      // console.log("this.minDateBranchOne ", this.minDateBranchOne)
      let minDateBranches = this.minDateBranchOne;
      if(minDateBranches) {
        this.minDateOne = moment.unix(minDateBranches).format("YYYY-MM-DD");
        this.minDateMomentOne = moment.unix(minDateBranches)
      } else {
        this.minDateOne = moment().format("YYYY-MM-DD");
        this.minDateMomentOne = moment()
      }

      // Check if minDate is in last Month
      if(this.minDateMomentOne  < moment().subtract(1,'month').endOf('month')){
        this.dataFilterOne.lastMonthAvailable = true
      }
      // Check if minDate is in last Quarter
      if(this.minDateMomentOne  < moment().subtract(1,'quarter').endOf('quarter')){
        this.dataFilterOne.lastQuarterAvailable = true
      }
      this.pickRangeLast30DaysOne()
      this.setSelectedDateOne()
    },

    setMininumDateTwo() {
      // console.log("this.minDateBranchTwo ", this.minDateBranchTwo)
      let minDateBranches = this.minDateBranchOne;
      if(minDateBranches) {
        this.minDateTwo = moment.unix(minDateBranches).format("YYYY-MM-DD");
        this.minDateMomentTwo = moment.unix(minDateBranches)
      } else {
        this.minDateTwo = moment().format("YYYY-MM-DD");
        this.minDateMomentTwo = moment()
      }

      // Check if minDate is in last Month
      if(this.minDateMomentTwo  < moment().subtract(1,'month').endOf('month')){
        this.dataFilterTwo.lastMonthAvailable = true
      }
      // Check if minDate is in last Quarter
      if(this.minDateMomentTwo  < moment().subtract(1,'quarter').endOf('quarter')){
        this.dataFilterTwo.lastQuarterAvailable = true
      }
      this.pickRangeLast30DaysTwo()
      this.setSelectedDateTwo()
    },

    dualMode() {
      // this.$refs.BarChartOne.resetChart();
      this.dualmode = true;
    },

    singleMode() {
      // this.$refs.BarChartOne.resetChart();
      this.dualmode = false;
    },

    closeSnackbarOne() {
      this.selectedOne = [];
    },

    closeSnackbarTwo() {
      this.selectedTwo = [];
    },

    loadCompanies() {
      db.collection("companies")
        .get()
        .then(snap => {
          this.companies = [];
          snap.forEach(doc => {
            let compCollection = doc.id;
            this.companies.push(compCollection);
          });
        });
    },

    loadActiveCompData() {
      db.collection("companies")
        .doc(this.activeComp)
        .get()
        .then(doc => {
          if (doc.exists) {
            this.activeCompData = doc.data();
            this.activeCompData.id = doc.id;
          } else {
            console.log("No such document!");
          }
        })
        .then(() => {
          this.activeCompDataOriginal = _.cloneDeep(this.activeCompData);
        })
        .catch(error => {
          console.log("Error getting document:", error);
        });
    },


    loadJourneyData() {
      
      //console.log("loadJourneyData is running: ",  this.selectedJourney);
      this.branches = [];
      this.stages = [];
      let companies = this.companies;

      // Alle geladen data in de grafiek en feedback op 0 zetten
      this.averangeRatingOne = 0;
      this.averangeRatingOnePercentage = 0;
      this.responsesNumberOne = 0;
      this.responseDataFeedbackOne = [];
      this.selectedOne = [];
      this.noSurveyDataOne = false;

      if (this.chartResultsOne.datasets.length > 0) {
        this.chartResultsOne.datasets = [];
        this.$refs.BarChartOne.resetChart();
      }

      this.averangeRatingTwo = 0;
      this.averangeRatingTwoPercentage = 0;
      this.responsesNumberTwo = 0;
      this.responseDataFeedbackTwo = [];
      this.selectedTwo = [];
      this.noSurveyDataTwo = false;
      if (this.chartResultsTwo.datasets.length > 0) {
        this.chartResultsTwo.datasets = [];
        this.$refs.BarChartTwo.resetChart();
      }

      companies.forEach(company => {

        // Load Branches
        if (company.journeys[this.selectedJourney] != undefined) {
          // console.log("Aanwezig bij: " + company.name);
          window.localStorage.setItem('selectedCompany', company.id)
          this.activeComp = company.id
          this.loadActiveCompData();
          this.branches = []
          if(this.userRole == 'superadmin' || this.userRole == 'admin'){
            db.collection("branches")
            .where("compId", "==", company.id)
            .get()
            .then(snap => {
              snap.forEach(doc => {
                let branchCollection = doc.data();
                branchCollection.id = doc.id;
                this.branches.push(branchCollection);
              });
            })
          }
          else{
            let counter = 0
            new Promise((resolve, reject)=>{
              this.userBranches.map(branch =>{
                db.collection("branches").doc(branch).get()
                .then(doc => {
                  let branchCollection = doc.data();
                  branchCollection.id = doc.id;
                  this.branches.push(branchCollection);
                  counter++
                  if(counter == this.userBranches.length){
                    resolve()
                  }
                })
              })
            })
          }
        }
        // else {
        //   console.log("Niet aanwezig bij: " + company.name);
        // }
      });

      // Load Stages
      db.collection("stages")
        .where("journeyId", "==", this.selectedJourney)
        .orderBy("order")
        .get()
        .then(snap => {
          snap.forEach(doc => {
            let stageCollection = {};
            stageCollection.id = doc.id;
            stageCollection.backgroundColor = doc.data().color;
            stageCollection.name = doc.data().name;
            stageCollection.order = doc.data().order;
            stageCollection.description = doc.data().description;
            stageCollection.journeyId = doc.data().journeyId;
            this.stages.push(stageCollection);
          });
        })
        .then(()=>{
          //console.log("Stages loaded");
          this.branchesLoaded();
        })
    },

    // Load Journey Results One
    loadDataOne() {
      this.loadingOne = true;
      this.responseDataOne = []
      this.responseDataFeedbackOne = []
      this.chartResultsOne = { datasets: [], labels: []}

      let start = new Date(this.dataFilterOneSaved.range[0]);
      let end = new Date(this.dataFilterOneSaved.range[1]);

      let selectedBranches = this.selectedOne;
      let selectedGender = this.genderSelectedOne;
      let selectedBranchData = [];
      let selectedBranchDataFeedback = [];

      // Load all surveys who fit criteria
      if (selectedGender == "male") {
        selectedBranches.map(element => {
          db.collection("surveys")
            .where("journeyId", "==", this.selectedJourney)
            .where("branchId", "==", element.id)
            .where("dateSend", ">=", start)
            .where("dateSend", "<=", end)
            .where("clientGender", "==", "male")
            .where("answered", "==", true)
            .orderBy("dateSend")
            .get()
            .then(snap => {
              snap.forEach(doc => {
                doc.data().surveyQuestions.forEach(question => {
                  if (question.rating > 0) {
                    const responseDataRating = question;
                    responseDataRating.survey = doc.id;
                    selectedBranchData.push(responseDataRating);
                  }
                  if (question.feedback) {
                    const responseDataFeedback = question;
                    responseDataFeedback.survey = doc.id;
                    responseDataFeedback.dateSend = doc.data().dateSend;
                    responseDataFeedback.branchId = doc.data().branchId;
                    responseDataFeedback.clientName = doc.data().clientName;
                    responseDataFeedback.clientLastTreatmentByName = doc.data().clientLastTreatmentByName;
                    selectedBranchDataFeedback.push(responseDataFeedback);
                  }
                });
              });
            })
            .then(() => {
              // console.log("Klaar met laden uit firebase");
            });
        });
      } else if (selectedGender == "female") {
        selectedBranches.map(element => {
          selectedBranches.map(element => {
            db.collection("surveys")
              .where("journeyId", "==", this.selectedJourney)
              .where("branchId", "==", element.id)
              .where("dateSend", ">=", start)
              .where("dateSend", "<=", end)
              .where("clientGender", "==", "female")
              .where("answered", "==", true)
              .orderBy("dateSend")
              .get()
              .then(snap => {
                snap.forEach(doc => {
                  doc.data().surveyQuestions.forEach(question => {
                    if (question.rating > 0) {
                      const responseDataRating = question;
                      responseDataRating.survey = doc.id;
                      selectedBranchData.push(responseDataRating);
                    }
                    if (question.feedback) {
                      const responseDataFeedback = question;
                      responseDataFeedback.survey = doc.id;
                      responseDataFeedback.dateSend = doc.data().dateSend;
                      responseDataFeedback.branchId = doc.data().branchId;
                      responseDataFeedback.clientName = doc.data().clientName;
                      responseDataFeedback.clientLastTreatmentByName = doc.data().clientLastTreatmentByName;
                      selectedBranchDataFeedback.push(responseDataFeedback);
                    }
                  });
                });
              })
              .then(() => {
                // console.log("Klaar met laden uit firebase");
              });
          });
        });
      } else if (selectedGender == "all") {
        selectedBranches.map(element => {
          db.collection("surveys")
            .where("journeyId", "==", this.selectedJourney)
            .where("branchId", "==", element.id)
            .where("dateSend", ">=", start)
            .where("dateSend", "<=", end)
            .where("answered", "==", true)
            .orderBy("dateSend")
            .get()
            .then(snap => {
              snap.forEach(doc => {

                doc.data().surveyQuestions.forEach(question => {
                  if (question.rating > 0) {
                    const responseDataRating = question;
                    responseDataRating.survey = doc.id;
                    selectedBranchData.push(responseDataRating);
                  }
                  if (question.feedback) {
                    const responseDataFeedback = question;
                    responseDataFeedback.survey = doc.id;
                    responseDataFeedback.dateSend = doc.data().dateSend;
                    responseDataFeedback.branchId = doc.data().branchId;
                    responseDataFeedback.clientName = doc.data().clientName;
                    responseDataFeedback.clientLastTreatmentByName = doc.data().clientLastTreatmentByName;
                    selectedBranchDataFeedback.push(responseDataFeedback);
                  }
                });
              });
            })
            .then(() => {
              // console.log("Klaar met laden uit firebase");
            });
        });
      }

      // console.log("Klaar met Surveys laden");

      this.responseDataOne = selectedBranchData;
      this.responseDataFeedbackOne = selectedBranchDataFeedback;

      db.collection("questions")
        .where("journeyId", "==", this.selectedJourney)
        .get()
        .then(snap => {
          this.questionDataChart = [];
          snap.forEach(doc => {
            let questionDataChart = {};
            questionDataChart.id = doc.id;
            questionDataChart.subject = doc.data().subject;
            questionDataChart.label = doc.data().question;
            questionDataChart.backgroundColor = doc.data().color;
            questionDataChart.data = [""];
            this.questionDataChart.push(questionDataChart);
          });
        })
        .then(() => {
          this.loadChartDataOne();
        })

        .then(() => {
          if (this.chartResultsOne.datasets.length > 0) {
            this.$refs.BarChartOne.resetChart();
            this.loadingOne = false;
            this.noSurveyDataOne = false;
          } else {
            this.noSurveyDataOne = true;
            this.loadingOne = false;
          }
        });
    },

    loadDataTwo() {
      this.loadingTwo = true;
      this.responseDataTwo = []
      this.responseDataFeedbackTwo = []
      this.chartResultsTwo = { datasets: [], labels: []}

      let start = new Date(this.dataFilterTwoSaved.range[0]);
      let end = new Date(this.dataFilterTwoSaved.range[1]);

      let selectedBranches = this.selectedTwo;
      let selectedGender = this.genderSelectedTwo;
      let selectedBranchData = [];
      let selectedBranchDataFeedback = [];

      // Load all surveys who fit criteria
      if (selectedGender == "male") {
        selectedBranches.map(element => {
          db.collection("surveys")
            .where("journeyId", "==", this.selectedJourney)
            .where("branchId", "==", element.id)
            .where("dateSend", ">=", start)
            .where("dateSend", "<=", end)
            .where("clientGender", "==", "male")
            .where("answered", "==", true)
            .orderBy("dateSend")
            .get()
            .then(snap => {
              snap.forEach(doc => {
                doc.data().surveyQuestions.forEach(question => {
                  if (question.rating > 0) {
                    const responseDataRating = question;
                    responseDataRating.survey = doc.id;
                    selectedBranchData.push(responseDataRating);
                  }
                  if (question.feedback) {
                    const responseDataFeedback = question;
                    responseDataFeedback.survey = doc.id;
                    responseDataFeedback.dateSend = doc.data().dateSend;
                    responseDataFeedback.branchId = doc.data().branchId;
                    responseDataFeedback.clientName = doc.data().clientName;
                    responseDataFeedback.clientLastTreatmentByName = doc.data().clientLastTreatmentByName;
                    selectedBranchDataFeedback.push(responseDataFeedback);
                  }
                });
              });
            })
            .then(() => {
              // console.log("Klaar met laden uit firebase");
            });
        });
      } else if (selectedGender == "female") {
        selectedBranches.map(element => {
          selectedBranches.map(element => {
            db.collection("surveys")
              .where("journeyId", "==", this.selectedJourney)
              .where("branchId", "==", element.id)
              .where("dateSend", ">=", start)
              .where("dateSend", "<=", end)
              .where("clientGender", "==", "female")
              .where("answered", "==", true)
              .orderBy("dateSend")
              .get()
              .then(snap => {
                snap.forEach(doc => {
                  doc.data().surveyQuestions.forEach(question => {
                    if (question.rating > 0) {
                      const responseDataRating = question;
                      responseDataRating.survey = doc.id;
                      selectedBranchData.push(responseDataRating);
                    }
                    if (question.feedback) {
                      const responseDataFeedback = question;
                      responseDataFeedback.survey = doc.id;
                      responseDataFeedback.dateSend = doc.data().dateSend;
                      responseDataFeedback.branchId = doc.data().branchId;
                      responseDataFeedback.clientName = doc.data().clientName;
                      responseDataFeedback.clientLastTreatmentByName = doc.data().clientLastTreatmentByName;
                      selectedBranchDataFeedback.push(responseDataFeedback);
                    }
                  });
                });
              })
              .then(() => {
                console.log("Klaar met laden uit firebase");
              });
          });
        });
      } else if (selectedGender == "all") {
        selectedBranches.map(element => {
          db.collection("surveys")
            .where("journeyId", "==", this.selectedJourney)
            .where("branchId", "==", element.id)
            .where("dateSend", ">=", start)
            .where("dateSend", "<=", end)
            .where("answered", "==", true)
            .orderBy("dateSend")
            .get()
            .then(snap => {
              snap.forEach(doc => {
                doc.data().surveyQuestions.forEach(question => {
                  if (question.rating > 0) {
                    const responseDataRating = question;
                    responseDataRating.survey = doc.id;
                    selectedBranchData.push(responseDataRating);
                  }
                  if (question.feedback) {
                    const responseDataFeedback = question;
                    responseDataFeedback.survey = doc.id;
                    responseDataFeedback.dateSend = doc.data().dateSend;
                    responseDataFeedback.branchId = doc.data().branchId;
                    responseDataFeedback.clientName = doc.data().clientName;
                    responseDataFeedback.clientLastTreatmentByName = doc.data().clientLastTreatmentByName;
                    selectedBranchDataFeedback.push(responseDataFeedback);
                  }
                });
              });
            })
            .then(() => {
              console.log("Klaar met laden uit firebase");
            });
        });
      }
      this.responseDataTwo = selectedBranchData;
      this.responseDataFeedbackTwo = selectedBranchDataFeedback;

      db.collection("questions")
        .where("journeyId", "==", this.selectedJourney)
        .get()
        .then(snap => {
          this.questionDataChart = [];
          snap.forEach(doc => {
            let questionDataChart = {};
            questionDataChart.id = doc.id;
            questionDataChart.subject = doc.data().subject;
            questionDataChart.label = doc.data().question;
            questionDataChart.backgroundColor = doc.data().color;
            questionDataChart.data = [""];
            this.questionDataChart.push(questionDataChart);
          });
        })
        .then(() => {
          this.loadChartDataTwo();
        })

        .then(() => {
          if (this.chartResultsTwo.datasets.length > 0) {
            this.$refs.BarChartTwo.resetChart();
            this.loadingTwo = false;
            this.noSurveyDataTwo = false;
          } else {
            this.noSurveyDataTwo = true;
            this.loadingTwo = false;
          }
        });
    },

    loadChartDataOne() {
      this.dataOne = true;
      let results = [];
      let average = [];
      let averageSum = "";
      let data = this.responseDataOne;
      let stages = this.stages;

      // console.log("Vragen data: ", this.questionDataChart);

      let countquestions = Object.keys(_.countBy(data, "question")); //Hoeveel verschillende vragen?
      let countStages = Object.keys(_.countBy(data, "stageId")); //Hoeveel verschillende stages?
      let countsurveys = Object.keys(_.countBy(data, "survey")); //Hoeveel verschillende vragen?
      this.responsesNumberOne = countsurveys.length; //Hoeveel verschillende resonses / surveys?

      // console.log("countStages: ", countStages);

      // Bereken gemiddelde score
      for (let a = 0; a < data.length; a++) {
        let averageRating = data[a].rating;
        average.push(averageRating);
      }
      averageSum = (_.sum(average) / average.length).toFixed(2);
      this.averangeRatingOne = averageSum;
      this.calculateAverageOne(averageSum);

      for (let q = 0; q < countStages.length; q++) {
        let questionfilter = _.filter(data, { stageId: countStages[q] }); //Filter de vraag

        let scorerespondenten = _.sumBy(questionfilter, "rating"); //Tel de score van de vraag op
        let scoreGem = scorerespondenten / Object.keys(questionfilter).length; //Deelt de Totale score door het aantel respondenten
        let totalAnswers = Object.keys(questionfilter).length;
        results.push({
          total: totalAnswers,
          id: countStages[q],
          data: [scoreGem.toFixed(2)]
        });
      }

      // console.log("results: ", results);

      let mergedresults = _.map(stages, function(stage) {
        return _.assign(
          stage,
          _.find(results, {
            id: stage.id
          })
        );
      });

      mergedresults = _.sortBy(mergedresults, "order");
      let removeZeroData = _.remove(mergedresults, function(currentObject) {
        return currentObject.data == null;
      });

      // console.log("Merge results: ", mergedresults); // <-- Klaar voor gebruik :)

      this.chartResultsOne = {
        datasets: mergedresults,
        labels: ['Score']
      };
    },

    calculateAverageOne(i) {
      this.averangeRatingOnePercentage = "";
      if (i > 0) {
        this.averangeRatingOnePercentage = (i * 20).toFixed(0) + "%";
        this.averangeRatingOne = i;
      } else {
        this.averangeRatingOnePercentage = 0;
        this.averangeRatingOne = 0;
      }
    },

    loadChartDataTwo() {
      this.dataTwo = true;
      let results = [];
      let average = [];
      let averageSum = "";
      let data = _.cloneDeep(this.responseDataTwo)
      let stages = _.cloneDeep(this.stages)
      // console.log("Vragen data: ", this.questionDataChart);

      let countquestions = Object.keys(_.countBy(data, "question")); //Hoeveel verschillende vragen?
      let countStages = Object.keys(_.countBy(data, "stageId")); //Hoeveel verschillende stages?
      let countsurveys = Object.keys(_.countBy(data, "survey")); //Hoeveel verschillende vragen?
      this.responsesNumberTwo = countsurveys.length; //Hoeveel verschillende resonses / surveys?

      // console.log("Stages: " + countStages.length);

      // Bereken gemiddelde score
      for (let a = 0; a < data.length; a++) {
        let averageRating = data[a].rating;
        average.push(averageRating);
      }
      averageSum = (_.sum(average) / average.length).toFixed(2);
      this.averangeRatingTwo = averageSum;
      this.calculateAverageTwo(averageSum);

      for (let q = 0; q < countStages.length; q++) {
        let questionfilter = _.filter(data, { stageId: countStages[q] }); //Filter de vraag
        let scorerespondenten = _.sumBy(questionfilter, "rating"); //Tel de score van de vraag op
        let scoreGem = scorerespondenten / Object.keys(questionfilter).length; //Deelt de Totale score door het aantel respondenten
        let totalAnswers = Object.keys(questionfilter).length;
        results.push({
          total: totalAnswers,
          id: countStages[q],
          data: [scoreGem.toFixed(2)]
        });
      }

      // console.log("results: ", results);

      let mergedresultsTwo = _.map(stages, function(stage) {
        return _.assign(
          stage,
          _.find(results, {
            id: stage.id
          })
        );
      });

      mergedresultsTwo = _.sortBy(mergedresultsTwo, "order");
      let removeZeroData = _.remove(mergedresultsTwo, function(currentObject) {
        return currentObject.data == null;
      });

      this.chartResultsTwo = {
        datasets: mergedresultsTwo,
        labels: ["score"]
      };
    },

    calculateAverageTwo(i) {
      this.averangeRatingTwoPercentage = "";
      if (i > 0) {
        this.averangeRatingTwoPercentage = (i * 20).toFixed(0) + "%";
        this.averangeRatingTwo = i;
      } else {
        this.averangeRatingTwoPercentage = 0;
        this.averangeRatingTwo = 0;
      }
    }
  },

  computed: {

    demoMode(){
      return this.$store.state.demoMode;
    },

     reviewsPackage(){
      let packageStatus = { 
        type: 'inactive',
        days: 0
      }

      if(this.activeCompData.packages && this.activeCompData.packages.length > 0 && _.indexOf(this.activeCompData.packages, 'customerjourney') >= 0){
        packageStatus.type = 'active';
      }
      else{
        // Package not purchased, check for active trial
        if(this.activeCompData.trials && this.activeCompData.trials.length > 0){
          this.activeCompData.trials.forEach(trailPackage =>{
            if(trailPackage.id == 'customerjourney'){
              // Trial found, check if trialperiod is still active
              if(moment(trailPackage.trialStartDate).add(trailPackage.trialDays, 'days') > moment()){
                packageStatus.type = 'trial';
                packageStatus.days = moment(trailPackage.trialStartDate).add(trailPackage.trialDays, 'days').diff(moment(), 'days')
              }
            }
          })
        }
      }
      return packageStatus
    },

    responseDataFeedbackOneFiltered(){
      let feedbackOne = _.sortBy(this.responseDataFeedbackOne, ['dateSend.seconds']);

      let feedbackFilteredOne = []
      let counter = 0
      if(feedbackOne.length > 0){
        for (var i = feedbackOne.length - 1; i >= 0; i--) {
          if(feedbackOne[i].feedback == "nvt" || feedbackOne[i].feedback == "n.v.t." || feedbackOne[i].feedback == " " || feedbackOne[i].feedback == "-"){
            
          } else{
            counter++
            if(counter <= 25){
               feedbackFilteredOne.push(feedbackOne[i])
            }
          }    
        }
      } 
      return feedbackFilteredOne
    },

    responseDataFeedbackTwoFiltered(){
      let feedbackTwo = _.sortBy(this.responseDataFeedbackTwo, ['dateSend.seconds']);
      let feedbackFilteredTwo = []

      let counter = 0
      if(feedbackTwo.length > 0){
        for (var i = feedbackTwo.length - 1; i >= 0; i--) {
          if(feedbackTwo[i].feedback == "nvt" || feedbackTwo[i].feedback == "n.v.t." || feedbackTwo[i].feedback == " " || feedbackTwo[i].feedback == "-"){
            
          } else{
            counter++
            if(counter <= 25){
              feedbackFilteredTwo.push(feedbackTwo[i])
            }
          }
        }
      }
      return feedbackFilteredTwo
    },

    flexClass(){
      if(this.dualmode){
        return 'xs12 md6'
      } else{
        return 'xs12'
      }
    },

    selectedSnackBarWidth(){
      if(this.dualmode){
        return 'xs2'
      } else{
        return 'xs3'
      }
    },

    dataSnackBarWidth(){
      if(this.dualmode){
        return 'xs4'
      } else{
        return 'xs3'
      }
    },  

    dualModeColor(){
      if(this.dualmode){
        return this.companySecondaryColor
      } 
      else{
        return '#b4bbc9'
      }
    },
    singleModeColor(){
      if(this.dualmode){
        return '#b4bbc9' 
      } 
      else{
        return this.companySecondaryColor
      }
    },

    loginError() {
      return this.$store.state.error;
    },
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userBranches() {
      return this.$store.state.userBranches;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    companyPrimaryColorRGBA() {
      return this.$store.state.companyPrimaryColorRGBA;
    },
    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    },
    filteredJourneys(){
      return this.journeys.filter(journey => {
        return journey.name.toLowerCase().includes(this.searchJourneys.toLowerCase());
      });
    }
  }
};
</script>

<style>
.custom-dropdown-icon{
  position: absolute;
  top: 50%;
  right: 12px;
  margin: -12px 0 0 0;
}

.results-select-data{
  position: relative;
  width: 100%;
  padding: 4px 8px;
  height: 48px;
  border-radius: 2px;
}

.results-select-data.light{
  background-color: #eee;
}

.results-select-data.dark{
  background-color: #333;
}

.datepicker-snackbar{
  width: 100%!important;
  position: relative;
  z-index: 999;
}

.datepicker-snackbar .datepicker-label{
  width: 35px;
  font-size: 14px;
  font-weight: 700;
  display: inline-block;
}
.datepicker-snackbar .datepicker-value{
  font-size: 14px;
}
.chart-container div{
  max-height: 200px;;
}
</style>
